import { render, staticRenderFns } from "./ReceiptDisbursement.vue?vue&type=template&id=a2c4382c&scoped=true"
import script from "./ReceiptDisbursement.vue?vue&type=script&lang=js"
export * from "./ReceiptDisbursement.vue?vue&type=script&lang=js"
import style0 from "./ReceiptDisbursement.vue?vue&type=style&index=0&id=a2c4382c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c4382c",
  null
  
)

export default component.exports